import {errorHandler} from "./common";

const axios = require('axios');

export function getCustomer(id) {
  return new Promise(function (resolve, reject) {
    console.log("Customer list ")
    axios.get(process.env.ROOT_API + 'admin/customer?id='+ id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getCustomers() {
  return new Promise(function (resolve, reject) {
    console.log("Customer list ")
    axios.get(process.env.ROOT_API + 'admin/customers', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function updateCustomer(user) {
  return new Promise(function(resolve, reject){
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'admin/customer', JSON.stringify(user), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Customer Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/customers.js